import React, { useState, useEffect, useRef } from "react";

import { getRecommend, getCustomSearchCategory,CategoryItem } from "../../api";
import {
  RECOMMENDCATEGORY,
  RECOMMENDRANGE,
  RECOMMENDSTATUS,
  BUSINESS_INFO
} from "../../constant";
import { recommendParamsFilter } from "../../utils";

import Location from "../Location";
import Pager from "../Pager";
import Placeholder from "../Placeholder";
import Radio from "../Radio";
import Recommend from "../Recommend";
import RecommendSort from "../RecommendSort";
import ReferenceValueRange from "../ReferenceValueRange";

import styles from "./RecommendList.module.css";

const PAGESIZE = 40;
interface RecommendProps {
  venderId: Number;
  publishSource: string;
}
const RecommendList: React.FC<RecommendProps> = props => {
  const { venderId, publishSource } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  const [list, setList] = useState([]);
  const [categoryIds, setCategoryIds] = useState(-1);
  const [merchantsStatus, setMerchantsStatus] = useState(-1);
  const [limitId, setLimited] = useState(-1);
  const [referenceLowerLimit, setReferenceLowerLimit] = useState(-1);
  const [referenceUpperLimit, setReferenceUpperLimit] = useState(-1);
  const [provinceId, setProvinceId] = useState(-1);
  const [cityId, setCityId] = useState(-1);
  const [countyId, setCountyId] = useState(-1);
  const [sortType, setSortType] = useState(1);
  const [keyWord, setKeyWord] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [empty, setEmtpy] = useState(false);
  const [recommendCategory, setRecommendCategory] = useState<CategoryItem[]>(
    []
  );

  const getRecommendCategory = () => {
    getCustomSearchCategory({ publishSource }).then((res) => {
      if (res && res.length > 0 && JSON.stringify(res) !== "{}") {
        let recommendCategory = [{ id: -1, name: "不限" }];
        for (let i = 0; i < res.length; i++) {
          const { thirdCateIds, name } = res[i];
          recommendCategory.push({
            id: thirdCateIds,
            name,
          });
        }
        setRecommendCategory(recommendCategory);
      }
    });
  };

  const fetchData = (current?: number) => {
    const auctionTypeMap = {
      [BUSINESS_INFO.POCHAN.code]: 5,
      [BUSINESS_INFO.HAIGUANANDZF.code]: 2,
      [BUSINESS_INFO.ZICHAN.code]: 4,
    };
    let params: any = {
      categoryIds: Array.isArray(categoryIds) ? categoryIds : [categoryIds],
      cityId,
      countyId,
      keyWord,
      merchantsStatus: merchantsStatus === 2 ? [2, 3] : [merchantsStatus],
      page: current || 1,
      pageSize: PAGESIZE,
      provinceId,
      referenceLowerLimit,
      referenceUpperLimit,
      sortType,
      venderIdList: [venderId],
      auctionType: auctionTypeMap[parseInt(publishSource)] || 4,
    };
    if (parseInt(publishSource) === BUSINESS_INFO.ZICHAN.code) {
      params.shopDisplay = 1; // 1 店铺页展示 0 店铺页不展示
    }
    getRecommend(recommendParamsFilter(params)).then((res) => {
      let { data, totalCount } = res;
      setList(data || []);
      setTotal(totalCount || 0);
      setEmtpy(!totalCount);
    });
  };

  useEffect(() => {
    getRecommendCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPage(1);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    categoryIds,
    cityId,
    countyId,
    keyWord,
    merchantsStatus,
    provinceId,
    referenceLowerLimit,
    referenceUpperLimit,
    sortType,
    venderId,
  ]);

  useEffect(() => {
    const target = containerRef.current as HTMLDivElement;
    const currentTop = target.getBoundingClientRect().top;
    const top = target.offsetTop - 51;
    if (currentTop < 0) {
      window.scrollTo(0, top);
    }
  }, [page]);

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.filter}>
        <Radio
          active={categoryIds}
          handler={(active) => setCategoryIds(active.id)}
          label="处置类型"
          list={recommendCategory}
        />
        <Location
          updateProvince={(id: number) => setProvinceId(id)}
          updateCity={(id: number) => setCityId(id)}
          updateCounty={(id: number) => setCountyId(id)}
        />
        {parseInt(publishSource) === BUSINESS_INFO.ZICHAN.code && (
          <Radio
            active={limitId}
            handler={(active) => {
              const { id, lower, upper } = active;
              setLimited(id);
              setReferenceLowerLimit(lower as number);
              setReferenceUpperLimit(upper as number);
            }}
            label="参考价值"
            list={RECOMMENDRANGE}
          />
        )}
        {parseInt(publishSource) === BUSINESS_INFO.POCHAN.code && (
          <ReferenceValueRange
            end={referenceUpperLimit.toString()}
            start={referenceLowerLimit.toString()}
            updateEnd={(end) => setReferenceUpperLimit(parseInt(end))}
            updateStart={(start) => setReferenceLowerLimit(parseInt(start))}
          />
        )}
        <Radio
          active={merchantsStatus}
          handler={(active) => setMerchantsStatus(active.id)}
          label="状态"
          list={RECOMMENDSTATUS}
        />
      </div>
      <RecommendSort
        active={sortType}
        handler={(active) => setSortType(active)}
        search={(keyword) => setKeyWord(keyword)}
        publishSource={publishSource}
      />
      {empty ? (
        <Placeholder text="暂无相关推介公告" />
      ) : (
        <div className={styles.list}>
          {list.map((item, index) => {
            return (
              <Recommend key={index} {...item} publishSource={publishSource} />
            );
          })}
        </div>
      )}
      <Pager
        current={page}
        pageSize={PAGESIZE}
        handler={(current) => {
          setPage(current);
          fetchData(current);
        }}
        total={total}
      />
      ;
    </div>
  );
}

export default RecommendList;
